The `Candidate` that applied for the position opening.

This will include the candidate's personal details along with all application profiles for a single hirer.

This field is only accessible while you have an active `ApplicationExport` relationship with the hirer.
If this relationship has been removed, it will return null along with a `FORBIDDEN` error.
